import { PageHeader } from '@/components'
import { Box, Button, Stack, styled, Typography } from '@mui/material'
import { PersonCard } from '@/components/partner'
import { useState } from 'react'
import { generatePath, useNavigate } from 'react-router-dom'
import { routes } from '@/router'
import { EditProfitShareDialog } from '@/components/partner/edit-profit-share-dialog'
import { useCompany } from '@/context/companies'

export function PartnersPage() {
  const { company } = useCompany()

  const navigate = useNavigate()

  const [isEditProfitShareDialogOpen, setIsEditProfitShareDialogOpen] =
    useState(false)

  const toggleEditProfitShareDialog = () => {
    setIsEditProfitShareDialogOpen(!isEditProfitShareDialogOpen)
  }

  const partners = company.partnerships || []

  return (
    <>
      <PageHeader rollbackRoute={routes.menu}>Sócios</PageHeader>

      <Box>
        <Button
          variant="outlined"
          size="small"
          onClick={toggleEditProfitShareDialog}
        >
          Alterar divisão de lucros
        </Button>
      </Box>

      <Stack spacing={2} my={3}>
        {partners.map(({ partner, company_share, profit_share }) => (
          <PersonCard
            key={partner.key}
            name={partner.name}
            onClick={() => {
              navigate(
                generatePath(routes.partners.data, {
                  partner_key: partner.key,
                }),
              )
            }}
          >
            <Box>
              <Typography>
                Cota:{' '}
                <StyledPercentage>{`${company_share ?? 0}%`}</StyledPercentage>
              </Typography>
              <Typography>
                Divisão de lucros:{' '}
                <StyledPercentage>{`${profit_share ?? 0}%`}</StyledPercentage>
              </Typography>
            </Box>
          </PersonCard>
        ))}
      </Stack>

      <EditProfitShareDialog
        open={isEditProfitShareDialogOpen}
        onClose={toggleEditProfitShareDialog}
      />
    </>
  )
}

const StyledPercentage = styled('span')(({ theme }) => ({
  backgroundColor: theme.palette.primary.light,
  color: theme.palette.common.white,
  padding: theme.spacing(0.25, 0.5),
  borderRadius: theme.shape.borderRadius,
  fontSize: 14,
}))
